import { render, staticRenderFns } from "./EditRecordingModal.vue?vue&type=template&id=4c3133ca&"
import script from "./EditRecordingModal.vue?vue&type=script&lang=js&"
export * from "./EditRecordingModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports